import { useEffect } from "react";

const BASE = process.env.REACT_APP_SITE_URL;

const setMeta = (selector, attr, value) => {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement(selector.startsWith("link") ? "link" : "meta");
        selector.match(/\[(\w+(?::\w+)?)="([^"]+)"\]/g)?.forEach((pair) => {
            const [, k, v] = pair.match(/\[([\w:]+)="([^"]+)"\]/);
            el.setAttribute(k, v);
        });
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
};

export const useSeo = ({ title, description, path = "/", image = "/og-image.jpg", noindex = false }) => {
    useEffect(() => {
        const url = `${BASE}${path}`;
        const img = `${BASE}${image}`;
        document.title = title;
        setMeta('meta[name="description"]', "content", description);
        setMeta('meta[name="robots"]', "content", noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
        setMeta('link[rel="canonical"]', "href", url);
        setMeta('meta[property="og:title"]', "content", title);
        setMeta('meta[property="og:description"]', "content", description);
        setMeta('meta[property="og:url"]', "content", url);
        setMeta('meta[property="og:image"]', "content", img);
        setMeta('meta[name="twitter:title"]', "content", title);
        setMeta('meta[name="twitter:description"]', "content", description);
        setMeta('meta[name="twitter:image"]', "content", img);
    }, [title, description, path, image, noindex]);
};

export const SEO = {
    home: {
        title: "Impianti di autolavaggio e attrezzature per officina in Calabria | FTM Group S.r.l.",
        description:
            "FTM Group, Castrolibero (Cosenza): concessionario Christ Wash Systems per la Calabria e rivenditore Ravaglioli. Portali e tunnel di lavaggio, autolavaggio self-service, lavaggio mezzi pesanti, ponti sollevatori, smontagomme, assetto ruote e attrezzature per centri revisione, con assistenza e ricambi in tutto il Sud Italia.",
        path: "/",
    },
    "privacy-policy": {
        title: "Privacy Policy | FTM Group S.r.l. – Castrolibero (Cosenza)",
        description:
            "Come FTM Group S.r.l. tratta i dati personali di chi visita www.ftmgroup.it o invia una richiesta di preventivo o assistenza: titolare, finalità, conservazione, fornitori e diritti dell'utente secondo il GDPR.",
        path: "/privacy-policy",
    },
    "cookie-policy": {
        title: "Cookie Policy | FTM Group S.r.l. – Castrolibero (Cosenza)",
        description:
            "Quali cookie usa il sito di FTM Group S.r.l.: solo cookie tecnici necessari e, con il tuo consenso, i video YouTube delle schede prodotto. Come gestire o revocare le preferenze in ogni momento.",
        path: "/cookie-policy",
    },
    admin: {
        title: "Area riservata | FTM Group S.r.l.",
        description: "Area riservata FTM Group.",
        path: "/admin",
        noindex: true,
    },
};
